import {MainWrapper} from "./MainWrapper";
import style from "../../assets/scss/sub/startGuide.module.scss";
import React, {useState} from "react";
import {PersonalStartGuide} from "./component/PersonalStartGuide";
import {OrganStartGuide} from "./component/OrganStartGuide";
import {MemberType} from "../../types/common";
import {useLanguage} from "../../hooks/hooks";
import {useTranslation} from "react-i18next";

export function StartGuide() {
  const { t } = useTranslation("startGuide");
  const [memberType, setMemberType] = useState(MemberType.PERSONAL);
  const {isKorean} = useLanguage();

  const setPersonalMember = () => {
    setMemberType(MemberType.PERSONAL);
  };

  const setGroupMember = () => {
    setMemberType(MemberType.GROUP);
  };

  return (
    <MainWrapper showFooter={true}>
      <>
        <div className={`${style.bgContainer} ${isKorean ? "" : style.en}`}>
          <div className={style.topBgWrapper}>
            <img src="https://images.feel-good.io/inspection_method/top_banner_background_1.png" className={style.topBg}
            alt={"top-banner-background"}/>
          </div>
          <div className={style.textContainer}>
            <div className={style.topBgSubText}>{t('subTitle')}</div>
            <div className={style.topBgMainText}>{t('title')}</div>
            <img src="https://images.feel-good.io/inspection_method/top_main_image.png" className={style.mainImage} alt={"top-main"}/>
          </div>
        </div>
        <div className={style.btnContainer}>
          <button
            className={`${style.indiBtn} ${memberType === "PERSONAL" ? style.isActive : ""} `}
            onClick={setPersonalMember}
          >
            {t('members.title')}
          </button>
          <button
            className={`${style.memberBtn} ${memberType === "GROUP" ? style.isActive : ""} `}
            onClick={setGroupMember}
          >
            {t('groupMembers.title')}
          </button>
        </div>

        {memberType === "PERSONAL" ? (
            <PersonalStartGuide />
        ) : (
           // 소속 회원 안내
            <OrganStartGuide />
        )}
      </>
    </MainWrapper>
  );
}
